import webengage from "@/webengage";
import React from "react";

export default function ContactUs({
  headerText,
  mainText,
  phoneNumber,
}: {
  headerText: string;
  mainText: string;
  phoneNumber: string;
}) {
  return (
    <div className="flex flex-col md:items-start text-white px-2">
      <div
        className=" flex text-[20px] text-black font-lato text-start"
        dangerouslySetInnerHTML={{ __html: headerText }}
      ></div>
      <p className="font-lato text-[16px] font-[400] md:font-[500] text-black mt-[16px] md:mt-[10px]">
        {mainText}
      </p>
      <div className="flex flex-row mt-[16px] space-x-[16px]">
        <img
          src="/main-website/WhatsApp-image.png"
          alt=""
          className="w-[60px] h-[60px]"
        />
        <a
          href={`https://wa.me/${phoneNumber}`}
          onClick={() => {
            const _webengage = webengage();
            if (_webengage) {
              _webengage.track("Contact Us", {
                source: "Astrolearn",
                type: "Chat",
              });
            }
          }}
          className="flex flex-col items-center justify-center"
        >
          <p className="font-lato text-[20px] text-black">Whatsapp us on</p>
          <p className="font-lato text-[20px] text-black">{phoneNumber}</p>
        </a>
      </div>
    </div>
  );
}
